/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Reports constructor Translation
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.0
 */

import { IPageNewsTranslation } from '@modules/internationalization/types/pages/news';

export const initPageNewsTranslation: IPageNewsTranslation = {
    userNews: {
        header: {
            title: '',
        },
        selectNewsMessage: '',
    },
    modals: {
        deleteModal: {
            title: '',
            start: { title: '', question: '' },
            success: '',
            error: '',
        },
        cancelModal: {
            title: '',
            text: '',
        },
        publishModals: {
            createExternalNewsModal: {
                title: '',
                start: '',
                success: '',
                error: '',
            },
            createInternalNewsModal: {
                title: '',
                start: '',
                success: '',
                error: '',
            },
            params: {
                title: '',
                publishFrom: '',
                publishTo: '',
            },
            errors: {
                'users.not.found': '',
            },
        },
    },
    manageNews: {
        header: {
            title: '',
            createNews: '',
        },
    },
    createNews: {
        header: {
            title: '',
        },
        internalTab: '',
        externalTab: '',
        requiredHint: '',
        form: {
            fields: {
                title: {
                    title: '',
                    hint: '',
                },
                link: { title: '', placeholder: '' },
                markdown: {
                    title: '',
                    hint: '',
                    guideLink: '',
                },
                images: {
                    title: '',
                    placeholder: '',
                    hint: '',
                    btnAdd: '',
                },
                publishFrom: '',
                publishTo: '',
                repeat: '',
                file: {
                    attach: '',
                    title: '',
                    hint: '',
                    tab1: '',
                    tab2: '',
                },
            },
            controls: {
                submit: '',
                preview: '',
                cancel: '',
            },
            notValid: '',
        },
    },
    previewNews: {
        header: {
            title: '',
        },
        controls: {
            submit: '',
            back: '',
        },
    },
    table: {
        id: {
            header: '',
        },
        type: {
            header: '',
        },
        title: {
            header: '',
        },
        publishFrom: {
            header: '',
        },
        publishTo: {
            header: '',
        },
        forAll: {
            header: '',
        },
        created: {
            header: '',
        },
        author: {
            header: '',
        },
    },
};
